// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* font */\n.g-text-oversized {\n  font-size: 1.2rem !important;\n  font-weight: 400;\n  line-height: 1.5rem;\n  letter-spacing: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
